'use strict';

exports.__esModule = true;
exports.getNodeHandlers = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _core = require('@nivo/core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
var getNodeHandlers = exports.getNodeHandlers = function getNodeHandlers(node, _ref) {
    var isInteractive = _ref.isInteractive,
        onClick = _ref.onClick,
        showTooltip = _ref.showTooltip,
        hideTooltip = _ref.hideTooltip,
        isZoomable = _ref.isZoomable,
        zoomToNode = _ref.zoomToNode,
        theme = _ref.theme,
        tooltipFormat = _ref.tooltipFormat;

    if (!isInteractive) return {};

    var handleTooltip = function handleTooltip(e) {
        showTooltip(_react2.default.createElement(_core.BasicTooltip, {
            id: node.id,
            value: node.value,
            enableChip: true,
            color: node.color,
            theme: theme,
            format: tooltipFormat
        }), e);
    };

    var clickHandler = onClick;
    if (isZoomable) {
        clickHandler = function clickHandler(event) {
            onClick(node, event);
            zoomToNode(node.path);
        };
    }

    return {
        onMouseEnter: handleTooltip,
        onMouseMove: handleTooltip,
        onMouseLeave: hideTooltip,
        onClick: clickHandler
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/@nivo/circle-packing/lib/interactivity.js
// module id = 218
// module chunks = 168707334958949